module.exports = __webpack_public_path__ + "static/media/minus.ca7db7f7.svg";